var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBarcodeScanner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10301_5131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9596 8.33333C23.3846 8.33333 22.918 7.86771 22.918 7.29167V3.125C22.918 2.55 22.4503 2.08333 21.8763 2.08333H17.7096C17.1346 2.08333 16.668 1.61771 16.668 1.04167C16.668 0.465625 17.1346 0 17.7096 0H21.8763C23.5992 0 25.0013 1.40208 25.0013 3.125V7.29167C25.0013 7.86771 24.5346 8.33333 23.9596 8.33333Z",
    fill: "#026C3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8763 25.0003H17.7096C17.1346 25.0003 16.668 24.5347 16.668 23.9587C16.668 23.3826 17.1346 22.917 17.7096 22.917H21.8763C22.4503 22.917 22.918 22.4503 22.918 21.8753V17.7087C22.918 17.1326 23.3846 16.667 23.9596 16.667C24.5346 16.667 25.0013 17.1326 25.0013 17.7087V21.8753C25.0013 23.5982 23.5992 25.0003 21.8763 25.0003Z",
    fill: "#026C3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.29167 25.0003H3.125C1.40208 25.0003 0 23.5982 0 21.8753V17.7087C0 17.1326 0.466667 16.667 1.04167 16.667C1.61667 16.667 2.08333 17.1326 2.08333 17.7087V21.8753C2.08333 22.4503 2.55104 22.917 3.125 22.917H7.29167C7.86667 22.917 8.33333 23.3826 8.33333 23.9587C8.33333 24.5347 7.86667 25.0003 7.29167 25.0003Z",
    fill: "#026C3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.04167 8.33333C0.466667 8.33333 0 7.86771 0 7.29167V3.125C0 1.40208 1.40208 0 3.125 0H7.29167C7.86667 0 8.33333 0.465625 8.33333 1.04167C8.33333 1.61771 7.86667 2.08333 7.29167 2.08333H3.125C2.55104 2.08333 2.08333 2.55 2.08333 3.125V7.29167C2.08333 7.86771 1.61667 8.33333 1.04167 8.33333Z",
    fill: "#026C3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7487 11.458C18.1737 11.458 17.707 10.9924 17.707 10.4163V7.29134H7.29036V10.4163C7.29036 10.9924 6.8237 11.458 6.2487 11.458C5.6737 11.458 5.20703 10.9924 5.20703 10.4163V7.29134C5.20703 6.14238 6.14141 5.20801 7.29036 5.20801H17.707C18.856 5.20801 19.7904 6.14238 19.7904 7.29134V10.4163C19.7904 10.9924 19.3237 11.458 18.7487 11.458Z",
    fill: "#026C3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.875 14.5837C21.875 15.1597 21.4083 15.6253 20.8333 15.6253H19.7917V17.7087C19.7917 18.8576 18.8573 19.792 17.7083 19.792H7.29167C6.14271 19.792 5.20833 18.8576 5.20833 17.7087V15.6253H4.16667C3.59167 15.6253 3.125 15.1597 3.125 14.5837C3.125 14.0076 3.59167 13.542 4.16667 13.542H20.8333C21.4083 13.542 21.875 14.0076 21.875 14.5837Z",
    fill: "#026C3D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10301_5131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarcodeScanner);
export default __webpack_public_path__ + "static/media/barcode-scanner.4ad230fae4f69f057b9fb3ab05e91b7f.svg";
export { ForwardRef as ReactComponent };